export const videoCollections = [
  {
    id: "collection-1",
    title: "2026年夏季最火影视合集",
    description: "收录今年夏季最受关注的热门电影和电视剧，一部不落全部整理给你！",
    platform: "妖精视频",
    platformSlug: "yaojing",
    category: "影视大全",
    categorySlug: "yingshidaquan",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20cinema%20movie%20collection%20poster%20collage%20with%20vibrant%20summer%20themed%20film%20posters%20on%20a%20dark%20cinematic%20background%20with%20warm%20spotlight%20effects%2C%20professional%20movie%20poster%20design%20style&width=800&height=450&seq=collection-1&orientation=landscape",
    count: 48,
    views: 128900,
    rating: 4.8,
  },
  {
    id: "collection-2",
    title: "经典港片怀旧特辑",
    description: "回味那些年我们一起追过的经典港片，满满的青春回忆都在这里。",
    platform: "桃花视频",
    platformSlug: "taohua",
    category: "影视大全",
    categorySlug: "yingshidaquan",
    thumbnail: "https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20movie%20poster%20collage%20with%20classic%20Chinese%20cinema%20scenes%20on%20vintage%20textured%20background%20with%20warm%20nostalgic%20golden%20tones%2C%20retro%20film%20poster%20aesthetic&width=800&height=450&seq=collection-2&orientation=landscape",
    count: 72,
    views: 95600,
    rating: 4.9,
  },
  {
    id: "collection-3",
    title: "高分纪录片精选推荐",
    description: "为你精心挑选的高分纪录片，从自然奇观到人文历史，开阔你的视野。",
    platform: "苹果视频",
    platformSlug: "pingguo",
    category: "纪录片",
    categorySlug: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Documentary%20film%20collection%20featuring%20nature%20and%20wildlife%20photography%20with%20stunning%20landscape%20aerial%20shots%20on%20clean%20minimal%20grid%20layout%2C%20educational%20documentary%20poster%20style%20with%20earthy%20tones&width=800&height=450&seq=collection-3&orientation=landscape",
    count: 36,
    views: 67300,
    rating: 4.7,
  },
  {
    id: "collection-4",
    title: "热门综艺一网打尽",
    description: "最新最热的综艺节目合集，让你笑到停不下来，周末放松必备。",
    platform: "榴莲视频",
    platformSlug: "liulian",
    category: "综艺娱乐",
    categorySlug: "zongyiyule",
    thumbnail: "https://readdy.ai/api/search-image?query=Variety%20show%20entertainment%20TV%20program%20collage%20with%20colorful%20vibrant%20stage%20lights%20and%20cheerful%20atmosphere%20on%20bright%20studio%20background%2C%20fun%20entertainment%20poster%20design%20with%20dynamic%20composition&width=800&height=450&seq=collection-4&orientation=landscape",
    count: 55,
    views: 156200,
    rating: 4.6,
  },
  {
    id: "collection-5",
    title: "国产剧年度口碑Top20",
    description: "年度评分最高的20部国产电视剧，每一部都值得你花时间去追。",
    platform: "豆花视频",
    platformSlug: "douhua",
    category: "热门剧集",
    categorySlug: "remenjuji",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20television%20drama%20series%20poster%20collection%20with%20elegant%20oriental%20aesthetic%20design%20elements%20on%20dark%20silk%20textured%20background%2C%20premium%20drama%20poster%20layout%20with%20rich%20cinematic%20colors&width=800&height=450&seq=collection-5&orientation=landscape",
    count: 20,
    views: 210500,
    rating: 4.9,
  },
  {
    id: "collection-6",
    title: "热门动漫追番指南",
    description: "2026年最值得追的热门动漫清单，从热血到治愈，总有一部是你的菜。",
    platform: "菠萝视频",
    platformSlug: "boluo",
    category: "动漫动画",
    categorySlug: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20collection%20poster%20featuring%20popular%20Japanese%20animation%20characters%20in%20dynamic%20action%20poses%20on%20vibrant%20colorful%20illustration%20background%2C%20contemporary%20anime%20art%20style%20with%20clean%20composition&width=800&height=450&seq=collection-6&orientation=landscape",
    count: 65,
    views: 189300,
    rating: 4.7,
  },
];

export const trendingVideos = [
  {
    id: "trend-1",
    title: "《狂飙2》全集高清免费在线观看",
    platform: "妖精视频",
    platformSlug: "yaojing",
    category: "热门剧集",
    categorySlug: "remenjuji",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20dark%20thriller%20poster%20with%20intense%20dramatic%20lighting%20and%20urban%20night%20scene%2C%20cinematic%20drama%20poster%20design%20with%20mysterious%20atmosphere&width=600&height=340&seq=trend-1&orientation=landscape",
    views: 892000,
    rating: 9.2,
  },
  {
    id: "trend-2",
    title: "《流浪地球3》终极预告片独家发布",
    platform: "苹果视频",
    platformSlug: "pingguo",
    category: "影视大全",
    categorySlug: "yingshidaquan",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20movie%20poster%20with%20epic%20space%20station%20and%20earth%20in%20background%2C%20futuristic%20cinematic%20visual%20style%20with%20dramatic%20blue%20and%20orange%20lighting&width=600&height=340&seq=trend-2&orientation=landscape",
    views: 756000,
    rating: 9.0,
  },
  {
    id: "trend-3",
    title: "《你好星期六》最新一期爆笑合集",
    platform: "桃花视频",
    platformSlug: "taohua",
    category: "综艺娱乐",
    categorySlug: "zongyiyule",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20colorful%20lights%20and%20cheerful%20hosts%20on%20bright%20studio%20set%2C%20entertainment%20TV%20show%20poster%20with%20fun%20and%20energetic%20vibe&width=600&height=340&seq=trend-3&orientation=landscape",
    views: 623000,
    rating: 8.8,
  },
  {
    id: "trend-4",
    title: "《斗罗大陆》最新篇章抢先看",
    platform: "榴莲视频",
    platformSlug: "liulian",
    category: "动漫动画",
    categorySlug: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20anime%203D%20animation%20fantasy%20adventure%20poster%20with%20martial%20arts%20characters%20on%20magical%20mountain%20landscape%2C%20epic%20oriental%20fantasy%20illustration%20style%20with%20dramatic%20lighting&width=600&height=340&seq=trend-4&orientation=landscape",
    views: 541000,
    rating: 9.1,
  },
  {
    id: "trend-5",
    title: "《地球脉动III》4K超清纪录片",
    platform: "豆花视频",
    platformSlug: "douhua",
    category: "纪录片",
    categorySlug: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20photography%20of%20animals%20in%20their%20natural%20habitat%2C%20epic%20landscape%20and%20wildlife%20cinematography%20style%20with%20warm%20natural%20lighting&width=600&height=340&seq=trend-5&orientation=landscape",
    views: 398000,
    rating: 9.5,
  },
  {
    id: "trend-6",
    title: "《NBA季后赛》精彩集锦回顾",
    platform: "菠萝视频",
    platformSlug: "boluo",
    category: "体育赛事",
    categorySlug: "tiyusaishi",
    thumbnail: "https://readdy.ai/api/search-image?query=Basketball%20NBA%20playoffs%20action%20shot%20with%20player%20dunking%20in%20packed%20arena%20with%20dramatic%20stadium%20lighting%2C%20sports%20photography%20style%20with%20intense%20athletic%20energy&width=600&height=340&seq=trend-6&orientation=landscape",
    views: 467000,
    rating: 8.9,
  },
];